import { APIEndpoints } from "@/data/constants/endpoints";
import { Request } from "@/data/api/utils/network";
import { RequestParams, TOrganizationUninvitePayload } from "@/data/types";
import {
  TOrganizationItem,
  TOrganizationPayload,
  TOrganizationInvitationPayload,
} from "@/data/types";

/**
 * Get all organizations with pagination options
 * @param params Request parameters including organization_id, pageNumber, pageSize, etc.
 */
export const getAllOrganizations = (params: RequestParams) => {
  return Request({
    path: APIEndpoints.ORGANIZATIONS.BASE,
    type: "GET",
    params,
  });
};

/**
 * Create a new organization
 * @param params Request parameters
 * @param payload Create payload
 */
export const createOrganization = (
  params: RequestParams,
  payload: TOrganizationPayload
) => {
  return Request({
    path: APIEndpoints.ORGANIZATIONS.BASE,
    type: "POST",
    params,
    body: payload,
  });
};

/**
 * Get a organization by ID
 * @param organizationId The ID of the organization to retrieve
 * @param params Request parameters
 */
export const getOrganizationById = (
  organizationId: string,
  params: RequestParams
) => {
  return Request({
    path: APIEndpoints.ORGANIZATIONS.BY_ID(organizationId),
    type: "GET",
    params,
  });
};

export const getCurrentOrganization = (params: RequestParams) => {
  return Request({
    path: APIEndpoints.ORGANIZATIONS.SELF,
    type: "GET",
    params,
  });
};

/**
 * Update a organization by ID
 * @param organizationId The ID of the organization to update
 * @param params Request parameters
 * @param payload Update payload
 */
export const updateOrganization = (
  organizationId: string,
  params: RequestParams,
  payload: Partial<TOrganizationPayload>
) => {
  return Request({
    path: APIEndpoints.ORGANIZATIONS.BY_ID(organizationId),
    type: "PATCH",
    params,
    body: payload,
  });
};

/**
 * Delete a organization by ID
 * @param organizationId The ID of the organization to delete
 * @param params Request parameters
 */
export const deleteOrganization = (
  organizationId: string,
  params: RequestParams
) => {
  return Request({
    path: APIEndpoints.ORGANIZATIONS.BY_ID(organizationId),
    type: "DELETE",
    params,
  });
};

/**
 * Get all organization invitations
 * @param params Request parameters including pagination options
 */
export const getOrganizationInvitations = (params: RequestParams) => {
  return Request({
    path: APIEndpoints.ORGANIZATIONS.INVITATIONS,
    type: "GET",
    params,
  });
};

/**
 * Create a new organization invitation
 * @param params Request parameters
 * @param payload Invitation payload (email, role, etc.)
 */
export const createOrganizationInvitation = (
  params: RequestParams,
  payload: TOrganizationInvitationPayload
) => {
  return Request({
    path: APIEndpoints.ORGANIZATIONS.INVITATIONS,
    type: "POST",
    params,
    body: payload,
  });
};

/**
 * Delete an organization invitation by ID
 * @param params Request parameters
 */
export const deleteOrganizationInvitation = (
  params: RequestParams,
  payload: TOrganizationUninvitePayload
) => {
  return Request({
    path: APIEndpoints.ORGANIZATIONS.INVITATIONS,
    type: "DELETE",
    params,
    body: payload,
  });
};

export const getAvailablePlanLedgers = (params: RequestParams) => {
  return Request({
    path: APIEndpoints.PLAN_LEDGERS.AVAILABLE,
    type: "GET",
    params,
  });
};
